<template>
    <NotificationTile :isNotificationRead="isNotificationRead">

        <template v-slot:icon>
            <TileIcon :size="50" padding="8px">
                <img :src="AppConfigs.staticImages.SPINTHEWHEEL" class="w-100"/>
            </TileIcon>
        </template>

        <template v-slot:title>{{ notification.body.message }}</template>
        <template v-slot:description>{{ formatTime(notification.createdAt) }}</template>

        <template v-slot:coins>
            {{ notification.body.coinsAmount }}
        </template>

    </NotificationTile>
</template>



<script lang="ts" setup>

import { useRouter } from 'vue-router';
import { PropType, computed } from 'vue';
import { AppConfigs } from "@/app.configs";
import { formatDistanceToNow } from 'date-fns';
import TileIcon from '@/components/Common/Tile-Icon.vue';
import NotificationTile from '@/components/Tiles/Notification/NotificationTile.vue';
import ISpinTheWheelNotification from '@/interfaces/Notifications/ISpinTheWheelNotification';


const props = defineProps({
    notification: {
        type: Object as PropType<ISpinTheWheelNotification>,
        required: true,
    },
});

const router = useRouter();

const isNotificationRead = computed(() => {
    return props.notification.readAt != null;
});

const formatTime = (time: number) => {
    return formatDistanceToNow(time * 1000) + ' ago';
}

</script>
